import React, { useState } from "react";
import {
  delete_icon,
  view_icon,
  search_icon,
  edit_icon,
} from "../../../assets/imgs";
import { useNavigate } from "react-router-dom";
import { Table } from "../../../components/Table/Table";

const SuperAdminList = () => {
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [superAdmin, setSuperAdmin] = useState();
  const [pagination, setPagination] = useState("");
  const [loader, setLoader] = useState(false);
  const [popup, setPopup] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);

  const [owners, setOwners] = useState([
    {
      "S.No": "01",
      adminID: "Rob90",
      name: "Robert",
      Owner: "Sathish (Rob90)",
      role: "Super Admin",
      "Registered Date": "12/02/2025",
      email: "robert@gmail.com",
      number: "2345678974",
      City: "Chennai",
      "Total Property Count": 12,
      status: "off",
    },
    {
      "S.No": "01",
      adminID: "Thor91",
      name: "Thor",
      Owner: "Sathish (Rob90)",
      role: " Admin",
      "Registered Date": "12/02/2025",
      email: "thor@gmail.com",
      number: "2345678974",
      City: "Chennai",
      "Total Property Count": 12,
      status: "off",
    },
    {
      "S.No": "01",
      adminID: "Rob90",
      name: "Robert",
      Owner: "Sathish (Rob90)",
      role: " Admin",
      "Registered Date": "12/02/2025",
      email: "robert@gmail.com",
      number: "2345678974",
      City: "Chennai",
      "Total Property Count": 12,
      status: "off",
    },
    {
      "S.No": "01",
      adminID: "Rob90",
      name: "Robert",
      Owner: "Sathish (Rob90)",
      role: " Admin",
      "Registered Date": "12/02/2025",
      email: "robert@gmail.com",
      number: "2345678974",
      City: "Chennai",
      "Total Property Count": 12,
      status: "off",
    },
    {
      "S.No": "01",
      adminID: "Rob90",
      name: "Robert",
      Owner: "Sathish (Rob90)",
      role: " Admin",
      "Registered Date": "12/02/2025",
      email: "robert@gmail.com",
      number: "2345678974",
      City: "Chennai",
      "Total Property Count": 12,
      status: "off",
    },
    {
      "S.No": "01",
      adminID: "Rob90",
      name: "Robert",
      Owner: "Sathish (Rob90)",
      role: " Admin",
      "Registered Date": "12/02/2025",
      email: "robert@gmail.com",
      number: "2345678974",
      City: "Chennai",
      "Total Property Count": 12,
      status: "off",
    },
    {
      "S.No": "01",
      adminID: "Rob90",
      name: "Robert",
      Owner: "Sathish (Rob90)",
      role: " Admin",
      "Registered Date": "12/02/2025",
      email: "robert@gmail.com",
      number: "2345678974",
      City: "Chennai",
      "Total Property Count": 12,
      status: "off",
    },
  ]);

  const handleStatus = ({ id }) => {
    const updatedData = [...owners]; // Create a copy of the data
    const currentStatus = updatedData[id].status || "on"; // Default to "on" if undefined

    updatedData[id].status = currentStatus === "on" ? "off" : "on";
    setOwners(updatedData);
    console.log("KK", id);
    // let value = data.filter((ele, i) => i == id ? ele.status == "off" ? "on" : "off")
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{(page - 1) * 10 + row.index + 1}</p>;
        },
      },
      // {
      //     Header: " Admin ID",
      //     accessor: "adminID",
      //     Cell: ({ value, row }) => {
      //         return <p>{value}</p>;
      //     },
      // },
      {
        Header: " Admin",
        accessor: "name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: " Mobile Number",
        accessor: "number",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: " Email",
        accessor: "email",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Role",
        accessor: "role",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <div>
              {row.original.role != "Super Admin" && (
                <button
                  onClick={() => {
                    // if (givenpermissions?.includes("CAN-Status-ADMINS")) {
                    handleStatus(row);
                    // handleStatus(row.original.id);
                    // }
                  }}
                  className={`${
                    value == "off" ? "deactive-btn" : "active-btn"
                  } border-0  fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13`}
                >
                  {value == "off" ? "De-active" : " Active"}
                </button>
              )}
              {/* {row.original.role != 'Super Admin' && (<button
                onClick={() => {
                  // if (givenpermissions?.includes("CAN-Status-ADMINS")) {
                  // handleStatus(row.original.id);
                  // }
                }}
                className={`${value == "off" ? "deactive-btn" : "active-btn"} border-0 ms-2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13 fs-xxl-18`}
              >
                {value == "off" ? "De-active" : " Active"}
              </button>)} */}
            </div>
          );
        },
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-jc gap-3">
                {/* {givenpermissions?.includes("CAN-View-ADMINS") && ( */}
                {row.original.role != "Super Admin" && (
                  <button
                    onClick={() => {
                      navigate("/super-admin-add", { state: { type: "view" } });
                      // AdminView(row.original.id, "view");
                    }}
                    className="cust-btn "
                  >
                    <img src={view_icon} alt="" className=" edit-btn " />
                  </button>
                )}
                {/* )} */}
                {/* {givenpermissions?.includes("CAN-Edit-ADMINS") && ( */}
                <button
                  onClick={() => {
                    navigate("/super-admin-add", { state: { type: "edit" } });
                    // AdminView(row.original.id, "edit");
                  }}
                  className="cust-btn "
                >
                  <img src={edit_icon} alt="" className=" edit-btn " />
                </button>
                {/* )}
                {givenpermissions?.includes("CAN-Delete-ADMINS") && ( */}
                {row.original.role != "Super Admin" && (
                  <button
                    onClick={() => setPopup(true)}
                    // onClick={() => setDeletePopup(row.original.id)}
                    className="cust-btn "
                  >
                    <img src={delete_icon} alt="" className=" edit-btn " />
                  </button>
                )}
                {/* )} */}
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    [page]
  );

  return (
    <div className="dashRightView ">
      <div className="d-flex ac-jb">
        <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
          Total:{owners.length}
        </h2>
        <div className="d-flex gap-3">
          <div className="search-input">
            <input
              //  onChange={(e) => (adminList(1, e.target.value))}
              type="text"
              placeholder="Search"
              style={{ border: "none", width: "150px" }}
            />
            <img src={search_icon} className="search" />
          </div>
          {/* {rolePermissions?.includes('CAN-ADD-ADMIN') && */}
          <button
            onClick={() =>
              navigate("/super-admin-add", { state: { type: "add" } })
            }
            className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn "
          >
            {" "}
            + Add Admin
          </button>
          {/* } */}
        </div>
      </div>
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={owners}
        show={true}
      />
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Delete?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={() => setPopup(false)} className="add-btn w-40">
                Yes
              </button>
              <button
                onClick={() => {
                  setPopup(false);
                  // logout();
                }}
                className="back-btn f2 w-40"
              >
                {/* {loading ? "Loading..." : "Confirm"} */}No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SuperAdminList;
